/* eslint-disable prefer-regex-literals */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
/* eslint-disable arrow-body-style */
/* eslint-disable no-lonely-if */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import 'features/dashboard/static/downtime/grid/grid.style.css';
import { useCommonInits } from 'hooks/useCommonInits';
import { useSelector } from 'react-redux';
import {
    Button,
    TextField,
    Select,
    MenuItem,
    FormControl,
    Box,
    Paper,
    Grid,
    OutlinedInput,
    InputLabel,
    FormControlLabel,
    Typography,
    Checkbox,
} from '@mui/material';
import { AppButton } from 'app/components/shared/AppButton';
import {
    getAllAssets,
    getAllGroups,
    getUserDetail,
    saveUser,
    updateUser,
    deleteUser,
    getApcmUserId,
} from 'redux/datasource/dataSourceActions';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import KeyIcon from '@mui/icons-material/Key';
import { DataGrid } from '@mui/x-data-grid';
import { AppConfirmDialog } from 'components/common/AppConfirmDialog';
import {
    getUserDetails,
    getUsersbyId,
    clearDataSource, 
    getAssets,
    getUser,
    getGroups,
} from 'redux/datasource/dataSourceSlice';
import { updatePanelContent } from 'redux/panels/panelsSlice';
// eslint-disable-next-line import/order
import PasswordModal from './changePass';
import { getParsedUnitIds } from 'redux/auth/authSlice';
import { decryptHash, generateHash } from 'utils/encryptDecrypt';
import PinOutlinedIcon from '@mui/icons-material/PinOutlined';
import { errorHandler } from 'utils/errorHandler';

export const User = panel => {
    const { dispatch, select } = useCommonInits();
    const userByID = select(getUsersbyId);
    const Groups = useSelector(getGroups);
    const loggedUser = useSelector(state => state.auth?.user);
    const { content } = panel;
    const [groupName, setGroupName] = useState([]);
    const [editgroupName, setEditGroupName] = useState([]);
    const [fName, setFName] = useState(content?.fName || '');
    const [lName, setLName] = useState(content?.lName || '');
    const [uName, setUName] = useState(content?.uName || '');
    const [pass, setPass] = useState(content?.pass || '');
    const [checked, setChecked] = useState(false);
    const [phone, setPhone] = useState('');
    const [appType, setAppType] = useState([]);
    const [appTypes, setAppTypes] = useState('APCM');
    const [email, setEmail] = useState('');
    const [fNameError, setFnameError] = useState(false);
    const [lNameError, setLnameError] = useState(false);

    const [uNameError, setUnameError] = useState(false);

    const [userType, setUserType] = useState('');
    const [cPass, setCPass] = useState('');
    const [role, setRole] = useState(
        content?.userType.substring(25, 100) || '',
    );
    const [showDialog, setShowDialog] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [groupId, setGroupId] = useState('');
    const users = select(getUserDetails);
    const [toggleButton, setToggleButton] = useState(true);
    const [error, setError] = useState({});
    const [deleteData, setDeleteData] = useState({});
    const [pageSize, setPageSize] = useState(10);
    const [errosMsg, setErrorMsg] = useState(false);
    const [errMsg, setErrMsg] = useState(false);
    const [errosMsg1, setErrorMsg1] = useState(false);
    const [ables, setAbles] = useState('Disable');
    const [controlPasswordFlag, setControlPasswordFlag] = useState(false);
    const [changeEmail, setChangeEmail] = useState('');
    const [allSelectedGroups, setAllSelectedGroups] = useState([]);
    // const strongRegex = new RegExp(
    //     // '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})',
    //     '^(?=.*[0-9a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*.]{8,}$',
    // );
    // eslint-disable-next-line no-useless-escape
    const strongRegex = /^(?![#$@\-=+<>&])(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/;

    const flnameRegex = new RegExp('^[a-zA-Z][a-zA-Z_]*$');
    const unameRegex = new RegExp('^[1-9a-zA-Z][0-9a-zA-Z_.@]*$');
    const phoneRegex = new RegExp('^[1-9][0-9]*$');
    const AppType = [
        { label: 'APCM_Authorizer', value: 'APCM_Authorizer' },
        { label: 'APCM_Executor', value: 'APCM_Executor' },
    ];
    const AppTypes = [{ label: 'APCM', value: 'APCM' }, ...AppType];

    const userGroup = Groups.map(obj => obj.name);
    const editGroup = [...new Set([...userGroup, ...editgroupName])];

    const ITEM_HEIGHT = 50;
    const ITEM_PADDING_TOP = 2;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: '22%',
            },
        },
    };

    useEffect(() => {
        dispatch(getUserDetail(appTypes));
    }, []);

    const selectUserEdit = id => {
        setGroupId(id);
        setToggleButton(false);
        if (users) {
            dispatch(getApcmUserId({ id }));
        }
    };

    useEffect(() => {
        if (Object.keys(userByID).length > 0) {
            setEmail(userByID.email);
            setFName(userByID.first_name);
            setLName(userByID.last_name);
            setUName(userByID.email);
            setPhone(userByID.user_contact);
            setPass(userByID.password);
            setChecked(userByID.microsoft_login);
            setAppType(userByID.app_type);
            if (userByID?.unit_id) { 
                setAllSelectedGroups(JSON.parse(userByID?.unit_id));
                const groupsS = JSON.parse(userByID?.unit_id)?.filter(val => {
                    return Groups.find(a => {
                        return a.name === val;
                    });
                })
                setGroupName(groupsS);
                setEditGroupName(groupsS);
            }
            setRole('Authorizer');
            setUserType('63ea16cf22d2c80001f01f41');
        }
    }, [userByID]);

    useEffect(() => {
        dispatch(
            updatePanelContent({
                ...content,
                groupName: groupName,
                fName: fName,
                lName: lName,
                uName: uName,
                pass: pass,
                cPass: cPass,
                appType: appType,
                phone: phone,
                roleId: '63ea16cf22d2c80001f01f41',
                role: 'Authorizer',
            }),
        );
    }, []);

    useEffect(() => {
        if (Groups) {
            dispatch(getAllGroups());
        }
    }, []);

    const handleDataChange = () => {
        dispatch(
            updatePanelContent({
                ...content,
                groupName: groupName,
                fName: fName,
                lName: lName,
                uName: uName,
                pass: pass,
                cPass: cPass,
                userType: userType,
                appType: appType,
                phone: phone,
                roleId: '63ea16cf22d2c80001f01f41',
                role: 'Authorizer',
                appTypes: appTypes,
            }),
        );
        if(flnameRegex.test(lName)){
        setLnameError(false);}
        if(flnameRegex.test(fName)){
        setFnameError(false);}
        if(flnameRegex.test(uName)){
        setUnameError(false);}
    };
    const params1 = () => {
        return {
            apptypes: appTypes,
        };
    };
    const selectUserDelete = () => {
        const params = {
            _id: deleteData._id,
        };
        dispatch(deleteUser({ params, params1: params1() }));
        setShowDialog(false);
    };

    const handleDialog = data => {
        if (data.email == loggedUser?.email) {
            errorHandler(dispatch, "Can't delete you are logged in!");
        }
        else {
            setShowDialog(true);
            setDeleteData(data);
        }
    };

    const handlePassDialog = (cEmail, flag) => {
        setOpenModal(true);
        setControlPasswordFlag(flag);
        setChangeEmail(cEmail);
    };

    const handleAppType = e => {
        setAppType([e.target.value]);
    };

    const handleAppTypes = e => {
        setAppTypes(e.target.value);
        dispatch(getUserDetail(e.target.value));
    };

    const onGroupSelect = event => {
        const {
            target: { value },
        } = event;
        const deselected = groupName.filter(item => !value?.includes(item));
        deselected?.map(item => {
            const index = allSelectedGroups.indexOf(item);
            if(index >= 0) {
                allSelectedGroups.splice(index, 1); 
            }
        })
        const changedUnits = [...new Set([...allSelectedGroups, ...value])];
        setGroupName(typeof value === 'string' ? value.split(',') : value);
        setAllSelectedGroups(changedUnits);
    };

    const handleControlPassword = event => {
        const value = event.target.value;
        setCPass(value);
        if (value.length > 0 && !strongRegex.test(value)) {
            setErrorMsg1(true);
        } else {
            setErrorMsg1(false);
        }
    };

    const handlePassword = event => {
        const value = event.target.value;
        setPass(value);
        if (value.length > 0 && !strongRegex.test(value)) {
            setErrorMsg(true);
        } else {
            setErrorMsg(false);
        }
    };

    const saveUsers = event => {
        event.preventDefault();
        setError({
            fName: !fName?.length,
            uName: !uName?.length,
            groupName: !groupName?.length,
        });
        const isPhoneValid =
            !phone || (phone?.length === 10 && phoneRegex.test(phone));
        const isLNameValid = !lName || flnameRegex.test(lName);

        if (
            (fName &&
                flnameRegex.test(fName) &&
                uName &&
                unameRegex.test(uName) &&
                groupName?.length &&
                errosMsg1 === false &&
                isPhoneValid &&
                isLNameValid &&
                pass?.length &&              
                strongRegex.test(pass)) ||
                checked
        ) {
            const params = {
                _role_id: '63ea16cf22d2c80001f01f41',
                email: uName,
                _id: groupId,
                password: pass === "" ? null : generateHash(pass),
                microsoft_login: ables,
                first_name: fName,
                role: 'Authorizer',
                last_name: lName,
                unit_id: JSON.stringify(groupName),
                app_type: appType,
                user_contact: phone === "" ? null : phone,
                control_password: generateHash(cPass),
            };

            dispatch(saveUser({ params, params1: params1() }));
            handleDataChange();
            clearFields();
        } else {
            if (!flnameRegex.test(fName)) {
                setFnameError(true);
            }
            if (!isLNameValid) {
                setLnameError(true);
            }
            if (!unameRegex.test(uName)) {
                setUnameError(true);
            }
            if (!strongRegex.test(pass)) {
                setErrorMsg(true);
            }
            if (!isPhoneValid) {
                setErrMsg(true);
            } else if (cPass?.length) {
                if (!strongRegex.test(cPass)) {
                    setErrorMsg1(true);
                }
            }
        }
    };

    const updateUsers = event => {
        event.preventDefault();
        setError({
            fName: !fName?.length,
            uName: !uName?.length,
            role: !role?.length,
            groupName: !allSelectedGroups?.length,
        });
        const isPhoneValid =
            !phone || (phone?.length === 10 && phoneRegex.test(phone));
        const isLNameValid = !lName || flnameRegex.test(lName);

        if (
            fName &&
            flnameRegex.test(fName) &&
            uName &&
            unameRegex.test(uName) &&
            role?.length &&
            allSelectedGroups?.length &&
            errosMsg1 === false &&
            isPhoneValid &&
            isLNameValid
        ) {
            const params = {
                _role_id: '63ea16cf22d2c80001f01f41',
                email: uName,
                _id: groupId,
                first_name: fName,
                microsoft_login: userByID?.microsoft_login,
                role: 'Authorizer',
                last_name: lName,
                unit_id: JSON.stringify(allSelectedGroups),
                app_type: appType,
                password: pass,
                user_contact: phone === "" ? null : phone,
            };
            dispatch(updateUser({ params, params1: params1() }));
            handleDataChange();
            clearFields();
            setToggleButton(true);
            // setErrMsg(false);
            dispatch(clearDataSource());
        } else {
            if (!isLNameValid) {
                setLnameError(true);
            } else if (!flnameRegex.test(fName)) {
                setFnameError(true);
            } else if (!isPhoneValid) {
                setErrMsg(true);
            } else if (!unameRegex.test(uName)) {
                setUnameError(true);
            } else if (cPass?.length) {
                if (!strongRegex.test(cPass)) {
                    setErrorMsg1(true);
                }
            }
        }
    };

    const renderDeleteDialog = () => (
        <AppConfirmDialog
            open={showDialog}
            title="Delete Confirmation"
            message="Are you sure you want to delete this user?"
            confirmText="Delete"
            cancelText="Cancel"
            onConfirm={selectUserDelete}
            onCancel={() => setShowDialog(false)}
        />
    );

    const clearFields = () => {
        setUName('');
        setAppType([]);
        setCPass('');
        setPass('');
        setFName('');
        setLName('');
        setChecked(false);
        setGroupName([]);
        setPhone('');
        setErrMsg(false);
        setErrorMsg(false);
        setErrorMsg1(false);
        setUnameError(false);
        setFnameError(false);
        setLnameError(false);
        dispatch(clearDataSource());
    };

    const clearAll = () => {
        clearFields();
        {
            toggleButton ? false : setToggleButton(true);
        }
    };

    const handleCheckboxChange = event => {
        setChecked(event.target.checked);
        if (checked === true) {
            setAbles('Disable');
        } else {
            setAbles('Enable');
        }
    };
    const columns = useMemo(
        () => [
            {
                field: 'first_name',
                headerName: 'First Name',
                width: 180,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'last_name',
                headerName: 'Last Name',
                width: 150,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'email',
                headerName: 'Username',
                width: 180,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'app_type',
                headerName: 'Apptype',
                width: 200,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },

            {
                field: 'action',
                headerName: 'Action',
                width: 250,
                sortable: false,
                filterable: false,
                editable: true,
                textAlign: 'center',
                renderCell: params => {
                    return (
                        <div>
                            <Button
                                onClick={() => selectUserEdit(params.row._id)}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                <EditIcon />
                            </Button>
                            <Button
                                onClick={() => handleDialog(params.row)}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                            <Button
                                onClick={() => handlePassDialog(params.row.email, false)}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                <KeyIcon />
                            </Button>
                            <Button
                                onClick={() => handlePassDialog(params.row.email, true)}
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                <PinOutlinedIcon />
                            </Button>
                        </div>
                    );
                },
            },
        ],
        [],
    );

    return (
        <>
            <Box sx={{ padding: 1 }}>
                <div
                    style={{
                        padding: 1,
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography variant='h4'>User List</Typography>
                    <div
                        style={{
                            width: '350px',
                            display: 'flex',
                            justifyContent: 'right',
                        }}
                    >
                        <label>
                            Apptype :
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={appTypes}
                                name="appTypes"
                                required
                                // input={<OutlinedInput label="Apptype" />}
                                onChange={handleAppTypes}
                                onBlur={handleDataChange}
                                size="small"
                                // fullWidth
                                sx={{ width: 200 }}
                            >
                                {AppTypes.map(item => {
                                    return (
                                        <MenuItem
                                            key={item.value}
                                            value={item.value}
                                        >
                                            {item.value}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </label>
                    </div>
                </div>
            </Box>
            {openModal && (
                <PasswordModal
                    isOpen={openModal}
                    handleCloseModal={() => setOpenModal(false)}
                    handlePasswordChange={handlePassDialog}
                    flag={controlPasswordFlag}
                    changeEmail={changeEmail}
                />
            )}
            <Paper variant="outlined">
                <Grid container>
                    <Grid item xs={3.5}>
                        <Paper
                            variant="outlined"
                            style={{
                                backgroundColor: 'transparent',
                            }}
                        >
                            <Box
                                sx={{
                                    borderBottom: 1,
                                    borderColor: 'divider',
                                    padding: 3,
                                }}
                                component="form"
                                noValidate
                            >
                                <div>
                                    <TextField
                                        hiddenLabel
                                        message="Fist Name is required"
                                        variant="outlined"
                                        value={fName || ''}
                                        name="fName"
                                        required
                                        label="First Name"
                                        error={error.fName}
                                        size="small"
                                        sx={{
                                            width: '100%',
                                          
                                        }}
                                        inputProps={{ maxLength: 20 }}
                                        style={styles.textBox}
                                        onChange={e => setFName(e.target.value)}
                                        onBlur={handleDataChange}
                                    />
                                    {fNameError ? (
                                        <label style={{ color: 'red' }}>
                                            Only alphabets & '_' is allowed
                                        </label>
                                    ) : (
                                        !fNameError
                                    )}

                                    <TextField
                                        hiddenLabel
                                        variant="outlined"
                                        value={lName || ''}
                                        name="lName"
                                        size="small"
                                        label="Last Name"
                                        sx={{
                                            width: '100%',
                                            // marginBottom: '20px'
                                        }}
                                        inputProps={{ maxLength: 20 }}
                                        style={{...styles.textBox,marginTop: '20px',}}
                                        onChange={e => setLName(e.target.value)}
                                        onBlur={handleDataChange}
                                    />
                                    {lNameError ? (
                                        <label style={{ color: 'red' }}>
                                            Only alphabets & '_' is allowed
                                        </label>
                                    ) : (
                                        !lNameError
                                    )}

                                    <TextField
                                        hiddenLabel
                                        variant="outlined"
                                        value={uName || ''}
                                        type='string'
                                        name="uName"
                                        required
                                        error={error.uName}
                                        label="Username"
                                        size="small"
                                        sx={{
                                            width: '100%',
                                            
                                           
                                        }}
                                        style={{...styles.textBox,marginTop: '20px',}}
                                        onChange={e => setUName(e.target.value)}
                                        onBlur={handleDataChange}
                                    />
                                    {uNameError ? (
                                        <label style={{ color: 'red', }}>
                                            Enter valid username
                                        </label>
                                    ) : (
                                        !uNameError
                                    )}
                                    <br/>
                                    {Object.keys(userByID).length === 0 ? (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={checked}
                                                    onChange={
                                                        handleCheckboxChange
                                                    }
                                                />
                                            }
                                            sx={{
                                                marginBottom: '7px',marginTop:'15px'
                                            }}
                                            label=" To sign in with Microsoft."
                                        />
                                    ) : null}
                                    {toggleButton ? (
                                        <span>
                                            <TextField
                                                hiddenLabel
                                                variant="outlined"
                                                value={pass || ''}
                                                disabled={
                                                    ables === 'Enable'
                                                        ? true
                                                        : false
                                                }
                                                name="pass"
                                                required
                                                type='password'
                                                label='Password'
                                                error={error.pass}
                                                size="small"
                                                inputProps={{ maxLength: 20 }}
                                                sx={{
                                                    width: '100%',
                                                    marginTop: '20px',
                                                }}
                                                style={styles.textBox}
                                                onChange={handlePassword}
                                                onBlur={handleDataChange}
                                            />
                                            {errosMsg ? (
                                                <label style={{ color: 'red' }}>
                                                    Password must contains
                                                    atleast 8 characters,
                                                    including
                                                    UPPERCASE/lowercase, numbers
                                                    & symbols.
                                                </label>
                                            ) : (
                                                !errosMsg
                                            )}
                                        </span>
                                    ) : (
                                        ''
                                    )}

                                    <TextField
                                        hiddenLabel
                                        variant="outlined"
                                        value={phone || ''}
                                        size="small"
                                        name="phone"
                                        type='number'
                                        label="Contact Number"
                                        error={error.phone}
                                        inputProps={{ maxLength: 10 }}
                                        sx={{
                                            width: '100%',
                                            marginTop: '20px',
                                        }}
                                        onChange={e => setPhone(e.target.value.trim())}
                                        onBlur={handleDataChange}
                                    />
                                    {errMsg ? (
                                        <label style={{ color: 'red' }}>
                                            Enter valid mobile number
                                        </label>
                                    ) : (
                                        !errMsg
                                    )}

                                    <FormControl
                                        sx={{
                                            width: '100%',
                                            marginRight: 100,
                                            marginBottom: 2,
                                            marginTop:2,
                                            paddingTop: 0.5,
                                            paddingBottom: 0.5,
                                        }}
                                    >
                                        <InputLabel id="demo-simple-select-label">
                                            Apptype
                                        </InputLabel>
                                        {/* {toggleButton ? ( */}
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={appType || []}
                                            name="appType"
                                            required
                                            input={
                                                <OutlinedInput label="Apptype" />
                                            }
                                            error={error.role}
                                            onChange={handleAppType}
                                            onBlur={handleDataChange}
                                            size="small"
                                        >
                                            {AppType.map(item => {
                                                return (
                                                    <MenuItem
                                                        key={item.value}
                                                        value={item.value}
                                                    >
                                                        {item.value}
                                                    </MenuItem>
                                                );
                                            })}
                                        </Select>
                                        {/* ) : (
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={userType || ''}
                                                name="role"
                                                required
                                                input={
                                                    <OutlinedInput label="Role" />
                                                }
                                                error={error.role}
                                                onChange={e =>
                                                    setUserType(e.target.value)
                                                }
                                                onBlur={handleDataChange}
                                                size="small"
                                            >
                                                {RolesEdit.map(item => {
                                                    return (
                                                        <MenuItem
                                                            key={item._id}
                                                            value={
                                                                item._id +
                                                                '#' +
                                                                item.role
                                                            }
                                                        >
                                                            {item.role}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                        )} */}
                                    </FormControl>
                                    <FormControl
                                        sx={{
                                            width: '100%',
                                            marginRight: 2,
                                            marginBottom: 2.5,
                                            paddingTop: 0.5,
                                            paddingBottom: 0.5,
                                        }}
                                    >
                                        <InputLabel id="demo-multiple-name-label">
                                            Groups
                                        </InputLabel>
                                        <Select
                                            labelId="demo-multiple-name-label"
                                            id="demo-multiple-name"
                                            multiple
                                            error={error.groupName}
                                            value={
                                                // groupName.map(group => group) 
                                                groupName
                                                ||
                                                []
                                            }
                                            onChange={onGroupSelect}
                                            input={
                                                <OutlinedInput label="Groups" />
                                            }
                                            MenuProps={MenuProps}
                                            renderValue={selected =>
                                                selected.join(', ')
                                            }
                                            sx={{ height: 40 }}
                                        >
                                            {editGroup.map(group => (
                                                <MenuItem
                                                    key={group}
                                                    value={group}
                                                    // disabled={!Groups.map(obj => obj.name).includes(group) && editgroupName.includes(group)}
                                                    style={
                                                        !Groups.map(
                                                            obj => obj.name,
                                                        ).includes(group) &&
                                                        editgroupName.includes(
                                                            group,
                                                        )
                                                            ? {
                                                                  backgroundColor:
                                                                      '#F83A37',
                                                              }
                                                            : {
                                                                  backgroundColor:
                                                                      'transparent',
                                                              }
                                                    }
                                                >
                                                    <Checkbox
                                                        checked={
                                                            groupName.indexOf(
                                                                group,
                                                            ) > -1
                                                        }
                                                    />
                                                    {group}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    {toggleButton && (<span><TextField
                                        hiddenLabel
                                        variant="outlined"
                                        type='password'
                                        value={cPass || ''}
                                        name="cPass"
                                        size="small"
                                        style={styles.textBox}
                                        sx={{
                                            width: '100%',
                                            marginTop: '20px',
                                        }}
                                        inputProps={{ maxLength: 20 }}
                                        label='Control Password'
                                        onChange={handleControlPassword}
                                        onBlur={handleDataChange}
                                    />
                                    {errosMsg1 && (
                                        <label style={{ color: 'red' }}>
                                            Control Password must contains
                                            atleast 8 characters, including
                                            UPPERCASE/lowercase, numbers &
                                            symbols.
                                        </label>
                                    )}</span>)
                                    }
                                    <br />

                                    {toggleButton ? (
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '5px',
                                            }}
                                        >
                                            <AppButton
                                                style={{
                                                    margin: '10px',
                                                }}
                                                variant='outlined'
                                                action={saveUsers}
                                            >
                                                Add
                                            </AppButton>

                                            <AppButton
                                                style={{
                                                    margin: '10px',
                                                }}
                                                variant='outlined'
                                                action={clearAll}
                                            >
                                                Clear
                                            </AppButton>
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                marginTop: '5px',
                                            }}
                                        >
                                            <AppButton
                                                style={{
                                                    margin: '10px',
                                                }}
                                                variant='outlined'
                                                action={updateUsers}
                                            >
                                                Update
                                            </AppButton>

                                            <AppButton
                                                style={{
                                                    margin: '10px',
                                                }}
                                                variant='outlined'
                                                action={clearAll}
                                            >
                                                Clear
                                            </AppButton>
                                        </div>
                                    )}
                                </div>
                            </Box>
                        </Paper>
                    </Grid>
                    &nbsp;&nbsp;
                    {showDialog && renderDeleteDialog()}
                    <Grid item xs={8.3}>
                        <Box
                            sx={{
                                height: '100%',
                                width: '100%',
                                paddingTop: 2,
                            }}
                        >
                            <Paper sx={{ width: '100%', height: '100%' }}>
                                <DataGrid
                                    disableColumnMenu
                                    rows={users}
                                    columns={columns}
                                    showCellRightBorder={true}
                                    showColumnRightBorder={true}
                                    getRowId={row => row._id}
                                    rowsPerPageOptions={[10, 25, 50]}
                                    pageSize={pageSize}
                                    onPageSizeChange={newPage =>
                                        setPageSize(newPage)
                                    }
                                    getRowSpacing={params => ({
                                        top: params.isFirstVisible ? 0 : -2,
                                        bottom: params.isLastVisible ? 0 : -2,
                                    })}
                                />
                            </Paper>
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
};

const styles = {
    unitsSelect: {
        marginTop: 2,
    },
    selectWidth: {
        height: 40,
        color: 'white',
        marginBottom: '20px',
        fontColor: 'black',
    },
    textBox: {
        height: 40,
        backgroundColor: 'transparent',
        marginTop: 2,
        borderWidth: 1,
        borderColor: 'white',
        color: 'white',
    },
    indeterminateColor: {
        color: '#f50057',
    },
    selectAllText: {
        fontWeight: 500,
    },
    selectedAll: {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
    },
};
